/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import useIsEditing from 'lib/hooks/useIsEditing';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getCtaStyle } from 'lib/utils/cta-utils';
import { getTestProps } from 'lib/testing/utils';
import { BrandAndThemeProvider } from 'lib/context/BrandAndThemeContext';
import { createCTAClickGTMEvent } from 'lib/utils/gtm-utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const OverlapCard = (props)=>{
    const { title, description, image, link } = props?.fields || {};
    const { RenderingIdentifier } = props?.params || {};
    const theme = props?.params?.selectTheme;
    const layout = props?.params?.layout || 'Wide';
    const styles = parseStyleParams(props.params, [
        'cta1'
    ]);
    const isEditing = useIsEditing();
    const { container, contentWrapper, imageWrapper, imageStyle, overlayContentwrapper, overlayContent, content, heading, rteContent, cta } = TAILWIND_VARIANTS({
        layoutType: layout
    });
    return /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
        theme: theme,
        children: /*#__PURE__*/ _jsx("section", {
            "data-component": "authorable/shared/content/overlapcard",
            ...editingHydrationProps(isEditing),
            id: RenderingIdentifier || undefined,
            ...getTestProps(`component-overlay-card-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx("div", {
                className: container(),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: contentWrapper(),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: imageWrapper(),
                            children: image?.value?.src ? /*#__PURE__*/ _jsx(ImageWrapper, {
                                field: image,
                                className: imageStyle(),
                                ...getTestProps(`image`)
                            }) : /*#__PURE__*/ _jsx(ImageWrapper, {
                                field: {
                                    value: {
                                        src: '/assets/profile_placeholder.png',
                                        alt: 'No image'
                                    }
                                },
                                className: imageStyle(),
                                ...getTestProps(`related-profile-image-placeholder`)
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: overlayContentwrapper(),
                            children: /*#__PURE__*/ _jsx("div", {
                                className: overlayContent(),
                                children: /*#__PURE__*/ _jsx(BrandAndThemeProvider, {
                                    theme: 'ThemesWhite',
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: content(),
                                        children: [
                                            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                                className: heading(),
                                                field: title,
                                                ...getTestProps(`heading`),
                                                tag: "h2"
                                            }),
                                            /*#__PURE__*/ _jsx(RichTextWrapper, {
                                                className: rteContent(),
                                                field: description,
                                                ...getTestProps(`description`)
                                            }),
                                            isEditing ? /*#__PURE__*/ _jsx("div", {
                                                className: cta(),
                                                children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                                    ctaComponentClass: "component-card-item-button-1-color",
                                                    ctaStyle: getCtaStyle(styles.cta1, styles?.cta1?.ctaVariant || 'primary'),
                                                    field: link,
                                                    suppressNewTabIcon: true,
                                                    ctaIcon: "arrow-right",
                                                    ...getTestProps(`primary-cta`),
                                                    gtmEvent: createCTAClickGTMEvent({
                                                        header: title?.value,
                                                        ctaText: link?.value?.text,
                                                        ctaType: 'blue',
                                                        componentName: 'Floating Card',
                                                        ctaLink: link?.value?.href
                                                    })
                                                })
                                            }) : link?.value?.href || link?.value?.anchor ? /*#__PURE__*/ _jsx("div", {
                                                className: cta(),
                                                children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                                    ctaComponentClass: "component-card-item-button-1-color",
                                                    ctaStyle: getCtaStyle(styles.cta1, styles?.cta1?.ctaVariant || 'primary'),
                                                    field: link,
                                                    suppressNewTabIcon: true,
                                                    ctaIcon: "arrow-right",
                                                    ...getTestProps(`primary-cta`),
                                                    gtmEvent: createCTAClickGTMEvent({
                                                        header: title?.value,
                                                        ctaText: link?.value?.text,
                                                        ctaType: 'blue',
                                                        componentName: 'Floating Card',
                                                        ctaLink: link?.value?.href
                                                    })
                                                })
                                            }) : /*#__PURE__*/ _jsx(_Fragment, {})
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
export const Default = withStandardComponentWrapper(OverlapCard);
const TAILWIND_VARIANTS = tv({
    defaultVariants: {
        layoutType: 'Wide'
    },
    slots: {
        container: [
            'w-full',
            'flex',
            'flex-col',
            'bg-component-section-bg',
            'py-component-section-container-padding-y'
        ],
        contentWrapper: [
            'w-full',
            'flex',
            'flex-col',
            'justify-space-between',
            'lg:flex-row lg:items-stretch',
            'bg-component-overlap-card-Color',
            'rounded-component-overlap-card-surface-radius',
            'shadow-color-black-alpha-10',
            'shadow-[0_0_8px_0]',
            'lg:rounded-none',
            'lg:shadow-none',
            'lg:bg-transparent'
        ],
        imageWrapper: [
            'w-full',
            'max-h-[288px] lg:max-h-none',
            'aspect-[328/288] md:aspect-[680/288] lg:aspect-video',
            'lg:w-[calc(50% + 85px)] lg:h-[calc(100% + 64px)] lg:relative lg:top-0',
            'lg:pb-[64px]'
        ],
        imageStyle: [
            'w-full',
            'max-h-[288px] lg:max-h-none lg:h-full',
            'object-cover',
            'aspect-[328/288] md:aspect-[680/288] lg:aspect-video',
            'rounded-component-overlap-card-surface-radius',
            'rounded-b-none',
            'lg:rounded-component-overlap-card-surface-radius',
            'z-0'
        ],
        overlayContentwrapper: [
            'w-full',
            'h-auto',
            'lg:w-[calc(50% + 85px)] lg:h-[calc(100% + 104px)]',
            'lg:relative',
            'lg:ml-[-170px]',
            'lg:pt-spacing-spacing-104',
            'relative',
            'z-10'
        ],
        overlayContent: [
            'w-full',
            'p-padding-loose',
            'lg:relative lg:min-h-full lg:bottom-0',
            'lg:bg-component-overlap-card-Color',
            'lg:rounded-component-overlap-card-surface-radius',
            'lg:shadow-color-black-alpha-10',
            'lg:shadow-[0_0_8px_0]'
        ],
        content: [
            'w-full',
            'flex flex-col gap-padding-base'
        ],
        heading: [
            'font-typography-font-family-header',
            'font-normal',
            'text-typography-font-size-medium',
            'text-component-card-on-surface-title',
            'leading-typography-line-height-medium'
        ],
        rteContent: [
            'w-full',
            'text-component-overlap-card-description',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'leading-typography-line-height-body-medium',
            'text-component-card-on-surface-body'
        ],
        cta: [
            'flex',
            'gap-spacing-spacing-8',
            'items-center',
            'justify-start',
            'w-fit'
        ]
    },
    variants: {
        layoutType: {
            Wide: {
                container: [
                    'relative',
                    'before:z-[-1]',
                    'before:h-full',
                    'before:absolute',
                    'before:bg-component-section-bg',
                    'before:top-0',
                    'before:left-[calc(-50vw+50%)]',
                    'before:right-[calc(-50vw+50%)]'
                ]
            },
            Full: {
                container: [
                    'relative'
                ]
            }
        }
    }
});
